import { render, staticRenderFns } from "./IconInvestBuy.vue?vue&type=template&id=6891c1b4&scoped=true&"
import script from "./IconInvestBuy.vue?vue&type=script&lang=js&"
export * from "./IconInvestBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6891c1b4",
  null
  
)

export default component.exports